import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class NotTranslatedService {
    constructor(private http: HttpClient, @Inject('ENV') public env: Env) {}
    notTranslated(key: string) {
        if (key.indexOf('route_') !== 0 && this.env.ENV === 'dev') {
            // this.http.get( `https://api.dev.ridango.com/v2/${this.env.REGION_ID}/translations/${key}` ).subscribe(
            //     d => {
            //         console.log( `Added ${key}`, d );
            //     },
            //     e => {
            //         console.log( 'Error adding', e );
            //     }
            // );
            // this.http.post( `https://api.dev.ridango.com/v2/${this.env.REGION_ID}/translations/log`, { tag: key } ).subscribe(
            //     d => { },
            //     e => {
            //         console.log( e );
            //     }
            // );
        }

        // do whatever you want...
    }
}
